export const CRFW = {
    wizard: {
        contactDetails: {
            commercial:
        'Please enter your company name and NIF. You must be authorised to act on behalf of the company.',
            companyNumber: 'NIF',
        },
    }    
};
